import React, { useContext } from 'react';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { useCurrentUser } from '../../../../utils/hooks/useCurrentUser';
import { ResourceType } from '../../../../types/resource';
import AuthorWatchButton from '../../../../Button/AuthorWatchButton';
import DeviationSidebarMosaic from '../../../_partials/DeviationSidebarMosaic';
import DeviationSidebarGrid from '../../../_partials/DeviationSidebarGrid';
import UserLink from '../../../../User/Link/UserLink';
import s from './UserBlock.scss';
var UserBlock = function (_a) {
    var user = _a.user, deviations = _a.deviations, parentDeviation = _a.parentDeviation;
    var isMobile = useContext(MobileContext);
    var fylt_suggested_users = useFlag('fylt_suggested_users');
    var fylt_suggested_users_more_by_watch = useFlag('fylt_suggested_users_more_by_watch');
    var currentUser = useCurrentUser();
    var showWatchButtonOnHover = fylt_suggested_users &&
        !fylt_suggested_users_more_by_watch &&
        !isMobile &&
        user.userId !== currentUser.userId;
    var showWatchButtonAlways = fylt_suggested_users_more_by_watch &&
        !fylt_suggested_users &&
        user.userId !== currentUser.userId;
    return (React.createElement(BiLoggerContextProvider, { value: {
            sectionid: user.userId,
            section_typeid: ResourceType.USER,
        } },
        React.createElement("div", { className: s['root'] },
            React.createElement("div", { className: s['user-header'] },
                React.createElement(UserLink, { className: s['user-link'], user: user }),
                showWatchButtonOnHover && (React.createElement(AuthorWatchButton, { className: s['watch-button-fylt_suggested_users'], author: user })),
                showWatchButtonAlways && (React.createElement(AuthorWatchButton, { className: s['watch-button-fylt_suggested_users_more_by_watch'], author: user }))),
            isMobile ? (React.createElement(DeviationSidebarMosaic, { streamId: "devpage-sidebar-users-".concat(parentDeviation.deviationId, "-").concat(user.userId), className: s['user-grid'], parentDeviation: parentDeviation, deviations: deviations })) : (React.createElement(DeviationSidebarGrid, { streamId: "devpage-sidebar-users-".concat(parentDeviation.deviationId, "-").concat(user.userId), className: s['user-grid'], parentDeviation: parentDeviation, deviations: deviations, maxRows: 1 })))));
};
UserBlock.displayName = 'UserBlock';
export default UserBlock;
//# sourceMappingURL=UserBlock.js.map